import { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import {
  purchaseCreditViewAction,
  purchaseInvoiceItemsGetAction,
  purchaseReturnItemsGetAction,
} from "../../../redux/actions/purchase-action";
import CreateEditViewPurCredit from "../../../components/purchase-section/purchase-credit-note/create-edit-view-pur-credit";

const AddPurchaseCredit = () => {
  const { itemId, type } = useParams();
  const itemIdArray = JSON.parse(decodeURIComponent(itemId));

  const [searchParams] = useSearchParams();
  const transfer=searchParams.has("transfer");
  //

  const cloneID = searchParams.get("cloneID");
  const isClone = cloneID ? true : false;
  //

  const allitems = itemIdArray.map((item) => {
    const { cmr_id, ...rest } = item;
    return rest;
  });
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {}, []);

  useEffect(() => {
    if (isClone) {
      setLoading(true);
      dispatch(purchaseCreditViewAction(cloneID, onCloneSuccPur, onErrPur));
    } else if (type === "return") {
      setLoading(true);
      dispatch(purchaseReturnItemsGetAction(allitems, onSuccPur, onErrPur));
    } else if (type === "invoice") {
      setLoading(true);
      dispatch(purchaseInvoiceItemsGetAction(allitems, onSuccPur, onErrPur));
    }
  }, []);

  const onCloneSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };
  const onSuccPur = (data) => {
    setOrderDetail(data?.data);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };
  const orderData = orderDetail?.orderData || {};
  const vendorDetails = orderDetail?.vendorDetails?.[0] || {};

  const prefix = searchParams.get("type") || "poit";
  const isNew = searchParams.has("new");

  return (
    <InnerLayout backBtn={true} title={`${isClone ? "Clone" : "Add"}  Purchase Credit Note`}>
      {loading ? (
        <LoadingSpinner />
      ) : (
        // <CreateEditViewPurchaseCredit
        <CreateEditViewPurCredit
          type={type}
          transfer={transfer===true}
          isClone={isClone}
          clickedplus={isNew}
          payto={
            isClone
              ? orderDetail?.orderData?.pct_pay_to_address
              : vendorDetails?.[`${prefix}_pay_to_address`]
          }
          shipto={
            isClone
              ? orderDetail?.orderData?.pct_ship_to_address
              : vendorDetails?.[`${prefix}_ship_to_address`]
          }
          page="add"
          pageType="purchase credit"
          orderDetail={orderDetail?.itemData}
          vendorDetails={
            isClone
              ? [orderDetail?.orderData]
              : [
                  {
                    ...vendorDetails,
                    pct_sub_total: orderData?.sub_total,
                    pct_total_gst: orderData?.total_tax,
                    pct_total_discount: orderData?.total_discount,
                    pct_total_amount: orderData?.total_amount,
                    pct_round_off_value: orderData?.round_off_value,
                    pct_tcs_or_tds_amount: orderData?.tcs_or_tds_amount,
                    pct_tcs_or_tds_percentage_id:
                      orderData?.tcs_or_tds_percentage_id,
                    pct_tcs_or_tds_percentage: orderData?.tcs_or_tds_percentage,
                    pct_tds_tcs_type: orderData?.tcs_or_tds_type,
                    pct_is_invoice_dis_percentage:
                      orderData?.is_invoice_dis_percentage ?? true,
                    pct_invoice_discount: orderData?.invoice_discount ?? 0,
                    pct_invoice_discount_percentage:
                      orderData?.invoice_discount_percentage ?? 0,
                  },
                ]
          }
        />
      )}
    </InnerLayout>
  );
};

export default AddPurchaseCredit;
